import React from 'react'
import classnames from 'classnames/bind'
import { Divider } from '@adc/ui-adc'
import { MarginSection } from 'common/modules/bidBanner/container'
import BidHistory from 'common/modules/bidHistory'
import BidHistoryTrigger from 'common/modules/bidBanner/bidHistorySection/trigger'
import { useListingContext } from 'common/context/listing'
import styles from './styles.scss'
import FAQLink from './faqLink'
const cx = classnames.bind(styles)

const FAQSection = () => {
  const { segment } = useListingContext()
  return (
    <MarginSection
      containerClassName={cx('container')}
      data-elm-id='faq_section'
      left
      right
    >
      <Divider />
      <div className={cx('faq-bid-history-container')}>
        <FAQLink />
        {segment?.__methods__.isOnlineAuctionActive() && (
          <BidHistory trigger={<BidHistoryTrigger />} />
        )}
      </div>
    </MarginSection>
  )
}

export default FAQSection
